export default "__VITE_ASSET__D_X8Pels__"